import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { Circles } from '../common/loadingComponent';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiGet, getHostApi } from '../../store/apiWrapper';
import ResponsiveTable from '../layoutItems/responsiveTable';
import Message from '../common/message';
import Money from '../common/moneyComponent';
import Check from '../../img/icons/Check';
import Cross from '../../img/icons/Cross';

import './clientAccounts.scss';

const MONITORA_TYPE = "Monitora";

class ClientAccounts extends React.Component {
    mounted = true;

    state = {
        error: null,
        isLoading: false,
        contract: null,
        accounts: null,
        details: {},
        detailsLoading: {},
        detailErrors: []
    };

    componentDidMount() {
        this.setState({ error: null, isLoading: true });
        apiGet(`${getHostApi()}/api/account/contract`, null,
            res => this.mounted && this.onSuccess(res),
            _ => this.mounted && this.setState({ error: this.props.translate('Common.Error') }),
            _ => this.mounted && this.setState({ isLoading: false })
        );
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <div className='card card-special'>
                <div className='card-body'>
                    {this.state.isLoading ? <Circles /> : <>
                        {this.state.error && <><Message type='error' message={this.state.error} /><br /></>}
                        <span><Translate id='User.ClientAccounts.AssignedContract' />: <strong>{this.state.contract}</strong></span>
                        <br />
                        <br />
                        <ResponsiveTable>
                            <table className='table table-report-section client-accounts'>
                                <thead>
                                    <tr>
                                        <th className='center'><Translate id='User.ClientAccounts.Active' /></th>
                                        <th className='center'><Translate id='User.ClientAccounts.Test' /></th>
                                        <th><Translate id='User.ClientAccounts.Type' /></th>
                                        <th><Translate id='User.ClientAccounts.ValidFrom' /></th>
                                        <th><Translate id='User.ClientAccounts.ValidTo' /></th>
                                        <th className='align-right'><Translate id='User.ClientAccounts.Credit' /></th>
                                        <th className='align-right'><Translate id='User.ClientAccounts.ConsumedCredit' /></th>
                                        <th><Translate id='User.ClientAccounts.Unit' /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(this.state.accounts) && this.state.accounts
                                        .sort((a, b) => ((a.validFrom < b.validFrom || (a.validFrom === b.validFrom && a.type > b.type)) ? 1 : -1))
                                        .map(acc => (
                                            <>
                                                <tr key={acc.id} className='colorize'>
                                                    <td className='client-accounts-table-center' data-label={this.props.translate('User.ClientAccounts.Active')}>
                                                        {acc.enabled ? <Check className='size-1em svg-standard-fill' /> : <Cross className='size-1em svg-standard-fill' />}
                                                    </td>
                                                    <td className='client-accounts-table-center' data-label={this.props.translate('User.ClientAccounts.Test')}>
                                                        {acc.test ? <Check className='size-1em svg-standard-fill' /> : <Cross className='size-1em svg-standard-fill' />}
                                                    </td>
                                                    <td className='wrap-by-letters' data-label={this.props.translate('User.ClientAccounts.Type')}>
                                                        <span>{acc.type}</span>
                                                    </td>
                                                    <td data-label={this.props.translate('User.ClientAccounts.ValidFrom')}>
                                                        <span>{acc.validFromFormated}</span>
                                                    </td>
                                                    <td data-label={this.props.translate('User.ClientAccounts.ValidTo')}>
                                                        <span>{acc.validToFormated}</span>
                                                    </td>
                                                    <td className='align-right' data-label={this.props.translate('User.ClientAccounts.Credit')}>
                                                        <Money value={acc.credit} fractionDigits={2} />
                                                    </td>
                                                    <td className='align-right' data-label={this.props.translate('User.ClientAccounts.ConsumedCredit')}>
                                                        <Money value={acc.consumedCredit} fractionDigits={2} />
                                                    </td>
                                                    <td data-label={this.props.translate('User.ClientAccounts.Unit')}>
                                                        <span>{acc.unit}</span>
                                                    </td>
                                                </tr>
                                                {this.renderDetail(acc.id, acc.type)}
                                            </>
                                        )
                                        )}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </>}
                </div>
            </div>
        )
    }

    renderDetail = (id, type) => {
        if (type === MONITORA_TYPE) {
            return (
                <>
                    <tr key={`${id}_detail_head`} className="colorize">
                        <td colSpan={2} style={{ visibility: "hidden" }}></td>
                        <td colSpan={2} style={{ fontWeight: "600" }}><Translate id="Report.Monitora.MonthlyMessageLimit" /></td>
                        <td colSpan={4} style={{ fontWeight: "600" }}><Translate id="Report.Monitora.RemainingMessages" /></td>
                    </tr>
                    <tr key={`${id}_detail_body`} className="colorize">
                        <td colSpan={2} style={{ visibility: "hidden" }}></td>
                        {(this.state.detailErrors.includes(MONITORA_TYPE) || this.state.detailsLoading[MONITORA_TYPE] || isNullOrUndefined(this.state.details[MONITORA_TYPE]))
                            ? <>
                                <td colSpan={2}>-</td>
                                <td colSpan={4}>-</td>
                            </>
                            : <>
                                <td colSpan={2}>{this.state.details[MONITORA_TYPE].monthly_limit}</td>
                                <td colSpan={4}>{this.state.details[MONITORA_TYPE].monthly_limit - this.state.details[MONITORA_TYPE].monthly_limit_used}</td>
                            </>
                        }
                    </tr>
                </>
            );
        }

        return null;
    }

    onSuccess = (res) => {
        const accounts = res.data.accounts;
        const details = {};
        const errors = [];

        this.setState({ detailsLoading: { ...this.state.detailsLoading, [MONITORA_TYPE]: true } });
        if (accounts.filter(f => f.type === MONITORA_TYPE).length > 0) {
            apiGet(`${getHostApi()}/api/report/monitora-limit`, null,
                s => {
                    details[MONITORA_TYPE] = s.data;
                    this.setState({ detailsLoading: { ...this.state.detailsLoading, [MONITORA_TYPE]: false } });
                },
                _ => errors.push(MONITORA_TYPE)
            );
        }

        this.setState({ contract: res.data.name, accounts: accounts, details: details, detailErrors: errors });
    }
}

export default withLocalize(ClientAccounts);